<div class="slider-editor-wrapper">
  <small class="debug">{{ me }}</small>
  <mat-drawer-container>
    <mat-drawer-content>
      <!-- Vertical floating toolbar on the right -->
      <div style="position: relative;" [class.dark-theme]="currentTheme === '0'">
        <div class="slider-wrapper">
          <div class="sidebar-container" [class.minimized]="sidebarMinimized">
            <div class="sidebar-header">
              <div class="sidebar-toggle-btn">
                @if (!sidebarMinimized) {
                  <mat-label
                    style="position: relative; top: -4px; left: -25px; font-size: 1.2em">{{ 'ai.slides' | transloco }}
                  </mat-label>
                }
                <button class="toggle-sidebar-btn"
                  (click)="toggleSidebar()"
                  [title]="sidebarMinimized ? ('ai.expandPreviewPanel' | transloco) : ('ai.minimizePreviewPanel' | transloco)">
                  <mat-icon>{{ sidebarMinimized ? 'keyboard_arrow_right' : 'keyboard_arrow_left' }}</mat-icon>
                </button>
              </div>
            </div>
            <!-- left side menu | Vertical minimized icons -->
            @if (sidebarMinimized) {
              <div class="sidebar-minimized-controls">
                <!-- Mobile expand button (only visible on screens <= 700px) -->

                <button class="mini-btn mobile-expand-btn"
                  [title]="'ai.expandPreviewPanel' | transloco"
                  (click)="toggleSidebar()">
                  <mat-icon>keyboard_arrow_right</mat-icon>
                </button>

                <button class="mini-btn"
                  [title]="'ai.addNewSlide' | transloco"
                  (click)="addNewSlide()">
                  <mat-icon>add</mat-icon>
                </button>
                <button class="mini-btn"
                  style="color: deepskyblue"
                  [title]="'ai.previewSlider' | transloco"
                  (click)="showPreviewPopup()">
                  <mat-icon>play_circle</mat-icon>
                </button>
                <button class="mini-btn"
                  [title]="'ai.edit' | transloco"
                  [disabled]="selectedSlideIndex === null"
                  (click)="onLightEdit()">
                  <mat-icon>edit</mat-icon>
                </button>
                <button class="mini-btn"
                  [title]="'ai.deleteSlide' | transloco"
                  [disabled]="selectedSlideIndex === null || loading"
                  (click)="onDeleteSlideFromMinimized()">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }

            <div class="sidebar-controls" [class.hidden]="sidebarMinimized">
              <div fxFlex fxLayoutAlign="space-between center">
                <button class="toolbar-btn"
                  [title]="'ai.addNewSlide' | transloco"
                  (click)="addNewSlide()">
                  <mat-icon>add</mat-icon>
                </button>

                <button class="toolbar-btn"
                  style="color: deepskyblue"
                  [title]="'ai.previewSlider' | transloco"
                  (click)="showPreviewPopup()">
                  <mat-icon>play_circle</mat-icon>
                </button>
                <button class="toolbar-btn"
                  [title]="'ai.deleteSlide' | transloco"
                  [disabled]="selectedSlideIndex === null"
                  (click)="onDeleteSlide()">
                  <mat-icon>delete</mat-icon>
                </button>
                <button class="toolbar-btn"
                  [title]="'ai.baseLayer' | transloco"
                  (click)="onSliderSettings()">
                  <mat-icon>{{ showMainLayout ? 'move_down' : 'move_up' }}</mat-icon>
                </button>
              </div>
              <!--                            <div class="view-toggle">-->
              <!--                                <button class="toggle-btn" [class.active]="viewMode === 'list'"-->
              <!--                                        (click)="setViewMode('list')" [title]="'ai.listView' | transloco">-->
              <!--                                    <mat-icon>density_medium</mat-icon>-->
            <!--                                </button>-->
            <!--                                <button class="toggle-btn" [class.active]="viewMode === 'grid'"-->
            <!--                                        (click)="setViewMode('grid')" [title]="'ai.gridView' | transloco">-->
            <!--                                    <mat-icon>grid_view</mat-icon>-->
          <!--                                </button>-->

          <!--                                &lt;!&ndash; Mobile toggle button (only visible on screens <= 700px) &ndash;&gt;-->
          <!--                                <button class="toggle-btn mobile-sidebar-toggle"-->
          <!--                                        (click)="toggleSidebar()"-->
          <!--                                        [title]="sidebarMinimized ? ('ai.expandPreviewPanel' | transloco) : ('ai.minimizePreviewPanel' | transloco)">-->
          <!--                                    <mat-icon>{{ sidebarMinimized ? 'keyboard_arrow_right' : 'keyboard_arrow_left' }}</mat-icon>-->
        <!--                                </button>-->
      <!--                            </div>-->
    </div>

    <div class="slides-thumb-container" [class.hidden]="sidebarMinimized"
      cdkDropList
      [cdkDropListData]="slideList"
      (cdkDropListDropped)="onDropSlide($event)">

      @for (slide of slideList; track slide.sceneId; let i = $index) {
        <div class="slide-item-wrapper"
          cdkDrag
          [cdkDragData]="slide"
          [class.selected-slide]="selectedSlideIndex === i"
          (click)="onSlideThumbClick(i, slide.sceneId)">

          <div class="drag-handle" cdkDragHandle>
            <mat-icon>drag_indicator</mat-icon>
          </div>

          <div class="slide-index">
            <span>{{ i + 1 }}</span>
          </div>

          <div class="slide-thumb">
            @if (viewMode === 'grid') {
              <app-slideer-item
                [isPreview]="true"
                [isThumb]="true"
                [sceneId]="slide.sceneId"
                [updated]="debouncedUpdated"
                (previewRequested)="showPreviewPopup()">
              </app-slideer-item>
            } @else {
              <div class="slide-label">
                <mat-icon>slideshow</mat-icon>
                <span>{{ slide.title }}</span>
              </div>
            }
          </div>


          <div class="slide-drag-preview" *cdkDragPreview>
            <div class="preview-content">
              <mat-icon>photo</mat-icon>
              <span>{{ slide.title }}</span>
            </div>
          </div>

          <div class="slide-drag-placeholder" *cdkDragPlaceholder></div>
        </div>
        } @empty {
        <!-- Empty state for sidebar slides -->
        <div class="empty-sidebar-message">
          <mat-icon class="empty-sidebar-icon">slideshow</mat-icon>
          <p>{{ 'ai.noSlidesYet' | transloco }}</p>
        </div>
      }
    </div>
  </div>

  @if (!showMainLayout) {
    <div class="slides-container">
      @for (slide of slideList; track slide.sceneId; let index = $index) {
        <div class="slide-item"
          [class.active]="editingSlideSceneId === slide.sceneId"
          [class.clickable]="editingSlideSceneId !== slide.sceneId"
          [class.transitioning]="slide.sceneId === transitioningSlideId"
          [attr.data-slide-id]="slide.sceneId"
          (click)="onMainSlideClick(index, slide.sceneId)">
          <div class="slide-smooth-wrapper">
            <app-slideer-item
              [isPreview]="editingSlideSceneId === slide.sceneId ? false : true"
              [isThumb]="false"
              [sceneId]="slide.sceneId"
              [updated]="updated"
              (previewRequested)="showPreviewPopup()"
              (touchAction)="onTouchAction()">
            </app-slideer-item>

          </div>
          <div class="menu-container">
            <button class="menu-btn" (click)="toggleSlideMenu($event, slide.id)">
              <mat-icon>more_vert</mat-icon>
            </button>
            @if (popupMenuId === slide.id) {
              <div class="popup-menu" (click)="$event.stopPropagation()">
                @if (editingSlideSceneId !== slide.sceneId) {
                  <button class="menu-item"
                    (click)="onMenuLightEdit(index, slide.sceneId, $event)">
                    <mat-icon>edit</mat-icon>
                    <span>{{ 'ai.edit' | transloco }}</span>
                  </button>
                }
                <button class="menu-item" (click)="onScenePropsSettings()">
                  <mat-icon>move_down</mat-icon>
                  <span>{{ 'ai.editBaseLayer' | transloco }}</span>
                </button>
                <button class="menu-item"
                  (click)="onDuplicateSlide(slide.sceneId, $event)">
                  <mat-icon>content_copy</mat-icon>
                  <span>{{ 'ai.duplicate' | transloco }}</span>
                </button>
                <button class="menu-item"
                  (click)="onAdvanceEditSlide(slide.sceneId, $event)">
                  <mat-icon>link</mat-icon>
                  <span>{{ 'ai.advancedEdit' | transloco }}</span>
                </button>
                <button class="menu-item"
                  (click)="onDeleteSlide(slide.sceneId, $event)">
                  <mat-icon>delete_outline</mat-icon>
                  <span>{{ 'ai.remove' | transloco }}</span>
                </button>
              </div>
            }
          </div>
        </div>

        } @empty {
        <!-- Empty state for main slides view -->
        <div class="empty-main-message">
          <mat-icon class="empty-main-icon">slideshow</mat-icon>
          <p>{{ 'ai.noSlidesInThisCollection' | transloco }}</p>
          <p class="empty-subtitle">{{ 'ai.addYourFirstSlideToGetStarted' | transloco }}</p>
        </div>
      }
    </div>
  } @else {
    <div class="slides-container settings-mode">
      <div class="slide-item active settings-scene"
        [attr.data-slide-id]="sliderSceneId">
        <div class="settings-badge">
          <mat-icon>settings</mat-icon>
          <span>{{ 'ai.baseCommonLayer' | transloco }}</span>
        </div>
        <div class="slide-smooth-wrapper">
          <app-slideer-item
            [isPreview]="false"
            [isThumb]="false"
            [sceneId]="sliderSceneId"
            [updated]="updated"
            [refresh]="refreshCounter"
            (previewRequested)="showPreviewPopup()"
            (touchAction)="onTouchAction()">
          </app-slideer-item>
        </div>
      </div>
    </div>
  }
</div>
</div>

<div class="floating-toolbar">
  <button class="toolbar-btn"
    title="{{ 'ai.text' | transloco }}"
    [disabled]="selectedSlideIndex === null"
    (click)="showTextTools()">
    <mat-icon>text_fields</mat-icon>
  </button>
  <button class="toolbar-btn"
    [title]="'ai.image' | transloco"
    [disabled]="selectedSlideIndex === null"
    (click)="onImage()">
    <mat-icon>image</mat-icon>
  </button>
  <button class="toolbar-btn"
    [title]="'ai.grid' | transloco"
    [disabled]="selectedSlideIndex === null"
    (click)="onGrid()">
    <mat-icon>grid_view</mat-icon>
  </button>
  <button class="toolbar-btn new-badge"
    [title]="'ai.newFeature' | transloco"
    [disabled]="selectedSlideIndex === null"
    (click)="onNewFeature()">
    <mat-icon>star</mat-icon>
    <span class="badge">{{ 'ai.new' | transloco }}</span>
  </button>
  <button class="toolbar-btn"
    [title]="'ai.settings' | transloco"
    [disabled]="selectedSlideIndex === null"
    (click)="onSettings()">
    <mat-icon>settings</mat-icon>
  </button>
  <button class="toolbar-btn"
    [title]="'ai.analytics' | transloco"
    [disabled]="selectedSlideIndex === null"
    (click)="onAnalytics()">
    <mat-icon>analytics</mat-icon>
  </button>
  <button class="toolbar-btn"
    [title]="'ai.layers' | transloco"
    [disabled]="selectedSlideIndex === null"
    (click)="onLayers()">
    <mat-icon>layers</mat-icon>
  </button>
  <button class="toolbar-btn"
    [title]="'ai.deleteSlide' | transloco"
    [disabled]="selectedSlideIndex === null"
    (click)="onDeleteSlide()">
    <mat-icon>delete</mat-icon>
  </button>
  <button class="toolbar-btn"
    [title]="'ai.search' | transloco"
    [disabled]="selectedSlideIndex === null"
    (click)="onSearch()">
    <mat-icon>search</mat-icon>
  </button>
</div>

<div class="tools-panel" [class.show]="showToolsPanel">
  <div class="tools-panel-header">
    <h3>{{ 'ai.basicBlocks' | transloco }}</h3>
    <button class="close-btn" (click)="closeToolsPanel()">
      <mat-icon class="size-sm">close</mat-icon>
    </button>
  </div>
  <div class="tools-panel-content">

    @for (category of blockCategories; track category.title) {
      <div
        cdkDropList
        cdkDropListSortingDisabled
        [cdkDropListData]="category.blocks"
        (cdkDropListDropped)="dropBlock($event)">

        <h4>{{ category.title }}</h4>

        <div class="block-list">
          @for (block of category.blocks; track block) {
            <div class="tool" cdkDrag [cdkDragData]="block"
              [matTooltip]="'ai.dragOrClickPlusIcon' | transloco">
              <mat-icon>{{ block.icon }}</mat-icon>
              <span>{{ block.label }}</span>
              <div class="tool-add-icon" (click)="addBlock(block)">
                <mat-icon class="size-xs">add</mat-icon>
              </div>
              <div *cdkDragPreview class="drag-preview">
                <mat-icon>{{ block.icon }}</mat-icon>
                <span>{{ block.label }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
</mat-drawer-content>
<mat-drawer [opened]="sidenavOpened" [mode]="sidenavMode" position="end" #sidenav disableClose
  style="overflow: visible !important; z-index: 0;">
  <div class="list-container" style="position: relative; height: 100%;">
    <div fxLayout="row" fxLayoutAlign="center" class="side-toggle2"
      (click)="minimized ? onMaximized() : onMinimized()">
      @if (!minimized) {
        <mat-icon class="size-sm">keyboard_arrow_right</mat-icon>
      } @else {
        <mat-icon class="size-sm">keyboard_arrow_left</mat-icon>
      }
    </div>

    <mat-drawer-container class="drawer-container" style="height: 100%">
      <mat-drawer mode="side" position="end" opened style="width: 72px">
        <div class="menu-button" [ngClass]="{'active': activeTemplate === 'details'}"
          (click)="setActiveTemplate('details')">
          <fa-icon size="xl" class="faNav" [icon]="faWrench"></fa-icon>
          {{ 'general.properties' | transloco }}
        </div>
        @if (isBlockAnimation && isNotNested && !multiple) {
          <div class="menu-button" [ngClass]="{'active': activeTemplate === 'animation'}"
            (click)="setActiveTemplate('animation')">
            <mat-icon>flare</mat-icon>
            {{ 'general.animation' | transloco }}
          </div>
        }
        @if (isNotNested && !multiple) {
          @if (showEffects) {
            <div class="menu-button"
              [ngClass]="{'active': activeTemplate === 'effects'}"
              (click)="setActiveTemplate('effects')">
              <mat-icon>blur_on</mat-icon>
              {{ 'general.effects' | transloco }}
            </div>
          }
        }
        @if (experienceLevel > experienceLevelType.BEGINNER) {
          <div class="menu-button" [ngClass]="{'active': activeTemplate === 'layers'}"
            (click)="setActiveTemplate('layers')">
            <fa-icon size="2xl" [icon]="faLayerGroup"></fa-icon>
            {{ 'general.layers' | transloco }}
          </div>
        }
        <div class="menu-button" [ngClass]="{'active': activeTemplate === 'components'}"
          (click)="setActiveTemplate('components')">
          <fa-icon size="2xl" [icon]="faPuzzlePiece"></fa-icon>
          {{ 'general.components' | transloco }}
        </div>
        @if (isMimeMainPlayer && experienceLevel > experienceLevelType.BEGINNER) {
          <div class="menu-button" [ngClass]="{'active': activeTemplate === 'scenes'}"
            (click)="setActiveTemplate('scenes')">
            <fa-icon size="2xl" [icon]="faLocationCrosshairs"></fa-icon>
            {{ 'general.scenes' | transloco }}
          </div>
        }
        <div class="menu-button" [ngClass]="{'active': activeTemplate === 'resources'}"
          (click)="setActiveTemplate('resources')">
          <fa-icon size="2xl" [icon]="faPhotoFilm"></fa-icon>
          {{ 'general.resources' | transloco }}
        </div>
        <div class="menu-button" [ngClass]="{'active': activeTemplate === 'stickers'}"
          (click)="setActiveTemplate('stickers')">
          <fa-icon size="2xl" [icon]="faAsterisk"></fa-icon>
          {{ 'general.stickers' | transloco }}
        </div>
        @if (experienceLevel > experienceLevelType.BEGINNER) {
          <div class="menu-button" [ngClass]="{'active': activeTemplate === 'addAnimation'}"
            (click)="setActiveTemplate('addAnimation')">
            <fa-icon size="2xl" [icon]="faArrowUpRightDots"></fa-icon>
            {{ 'general.motion' | transloco }}
          </div>
        }
        <div class="menu-button" [ngClass]="{'active': this.activeTemplate === 'backgrounds'}"
          (click)="setActiveTemplate('backgrounds')">
          <fa-icon size="2xl" [icon]="faImage"></fa-icon>
          {{ 'general.backgrounds' | transloco }}
        </div>
        <div class="menu-button" [ngClass]="{'active': this.activeTemplate === 'icons'}"
          (click)="setActiveTemplate('icons')">
          <fa-icon size="2xl" [icon]="faIcons"></fa-icon>
          {{ 'general.icons' | transloco }}
        </div>
      </mat-drawer>
      <mat-drawer-content [style.width.px]="minimized ? 0 : 265" style="height: 100%;">
        <div class="propertyPanel">
          <ng-container *ngTemplateOutlet="getTemplate(activeTemplate)"></ng-container>
          <ng-template #detailsTemplate>
            <mat-accordion [multi]="false" class="accordion-container">
              <mat-expansion-panel #propPanel portalHandler [expanded]="true"
                (opened)="panelOpenState = true"
                (closed)="panelOpenState = false" class="scrollable-panel">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    @if (blockName === 'scene' || !blockName) {
                      <mat-icon>settings</mat-icon>
                      <span
                      class="accordionIcons">{{ 'general.properties' | transloco }}</span>
                    } @else if (blockIcon) {
                      <fa-icon class="faIconPosition" size="lg"
                      [icon]="blockIcon"></fa-icon>
                      <span class="accordionIcons">{{ blockMimeName }}</span>
                    }
                  </mat-panel-title>
                  <mat-panel-description>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                  @if (blockName === 'scene' || !blockName) {
                    <app-slideer-navigation
                      [setSliderScene]="sliderScene"
                      [showMainLayout]="showMainLayout"
                      (remove)="removeNavigationButtons(true)"
                      (update)="resetNavigation(false, $event)"
                      (selectFirstSlide)="onSlideThumbClick($event.index, $event.slideSceneId)"
                      (addMenu)="addNavigationMenu($event)"
                      (removeMenu)="removeNavigationMenu()"
                    ></app-slideer-navigation>
                  } @else {
                    <div [@fadeProperty]="visibility"
                      (@fadeProperty.done)="animationDone($event)">
                      <app-block-loader></app-block-loader>
                    </div>
                  }
                </ng-template>
              </mat-expansion-panel>
              @if (blockName && blockName !== 'scene' && isDataProvider) {
                <mat-expansion-panel portalHandler class="scrollable-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <fa-icon size="lg" class="faIconPosition" [icon]="faHdd"></fa-icon>
                      <span class="accordionIcons">
                        {{ 'ai.dataProvider' | transloco }}
                      </span>
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <ng-template matExpansionPanelContent>
                    <app-block-data-provider></app-block-data-provider>
                  </ng-template>
                  @if (!accessConfig?.upd) {
                    <div class="only-view"></div>
                  }
                </mat-expansion-panel>
              }

              @if (blockName && blockName !== 'scene') {
                <mat-expansion-panel portalHandler #layoutPanel class="scrollable-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <fa-icon size="lg" class="faIconPosition"
                      [icon]="faObjectUngroup"></fa-icon>
                      <span
                      class="accordionIcons">{{ 'general.layout' | transloco }}</span>
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>

                    @if (layoutPanel.expanded && experienceLevel > experienceLevelType.BEGINNER) {
                      <app-video-link style="position: absolute; right: 40px; top: 15px"
                      videoLink="layout"></app-video-link>
                    }

                  </mat-expansion-panel-header>
                  <ng-template matExpansionPanelContent>
                    <app-block-layout-common-props></app-block-layout-common-props>
                    @if (!accessConfig?.upd) {
                      <div class="only-view"></div>
                    }
                  </ng-template>
                </mat-expansion-panel>
              }

              @if (showEvents && experienceLevel == experienceLevelType.ADVANCED && blockName && blockName !== 'scene') {
                <mat-expansion-panel #eventPanel portalHandler class="scrollable-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <fa-icon size="lg" class="faNav" [icon]="faBell"></fa-icon>
                      <span
                      class="accordionIcons">{{ 'general.events' | transloco }}</span>
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                    @if (eventPanel.expanded) {
                      <app-video-link style="position: absolute; right: 40px; top: 15px"
                      videoLink="Button"></app-video-link>
                    }
                  </mat-expansion-panel-header>
                  <ng-template matExpansionPanelContent>
                    <mat-tab-group [@.disabled]="true" tabGroupDrag mat-stretch-tabs="false"
                      mat-align-tabs="start">
                      @if (isBlockAdvEvents?.send) {
                        <mat-tab label="{{'general.sendEvents' | transloco}}">
                          <app-block-send-events></app-block-send-events>
                        </mat-tab>
                      }
                      @if (isBlockAdvEvents?.receive) {
                        <mat-tab
                          label="{{'general.receiveEvents' | transloco}}">
                          <app-block-receive-events></app-block-receive-events>
                        </mat-tab>
                      }
                      @if (isBlockAdvEvents?.source) {
                        <mat-tab
                          label="{{'general.eventSource' | transloco}}">
                          <app-block-event-source></app-block-event-source>
                        </mat-tab>
                      }
                      @if (isBlockAdvEvents?.filter) {
                        <mat-tab label="{{'general.filters' | transloco}}">
                          <app-block-filter-events></app-block-filter-events>
                        </mat-tab>
                      }
                    </mat-tab-group>
                  </ng-template>
                  @if (!accessConfig?.upd) {
                    <div class="only-view"></div>
                  }
                </mat-expansion-panel>
              }
              @if (showPop && experienceLevel == experienceLevelType.ADVANCED) {
                <mat-expansion-panel #popPanel portalHandler class="scrollable-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <fa-icon size="lg" class="faNav" [icon]="faReceipt"></fa-icon>
                      <span
                      class="accordionIcons">{{ 'general.proofOfPlay' | transloco }}</span>
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                    @if (popPanel.expanded) {
                      <app-video-link style="position: absolute; right: 40px; top: 15px"
                      videoLink="sign_pop"></app-video-link>
                    }
                  </mat-expansion-panel-header>
                  <ng-template matExpansionPanelContent>
                    <app-block-pop></app-block-pop>
                  </ng-template>
                  @if (!accessConfig?.upd) {
                    <div class="only-view"></div>
                  }
                </mat-expansion-panel>
              }
              @if (isFullFeatures && scriptingMode && isSceneButNotNested && experienceLevel == experienceLevelType.ADVANCED) {
                <mat-expansion-panel portalHandler class="scrollable-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <fa-icon size="lg" class="faNav" [icon]="faCode"></fa-icon>
                      <span
                      class="accordionIcons">{{ 'general.scripts' | transloco }}</span>
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <ng-template matExpansionPanelContent>
                    <app-block-scripts
                    [setSelectedSceneId]="editingSlideSceneId"></app-block-scripts>
                    @if (!accessConfig?.upd) {
                      <div class="only-view"></div>
                    }
                  </ng-template>
                </mat-expansion-panel>
              }
            </mat-accordion>
          </ng-template>

          <ng-template #animationTemplate>
            <app-block-animation-group></app-block-animation-group>
          </ng-template>

          <ng-template #effectsTemplate>
            <app-block-effect-group></app-block-effect-group>
          </ng-template>

          <ng-template #layersTemplate>
            <app-scene-layers></app-scene-layers>
          </ng-template>
          <ng-template #componentsTemplate matExpansionPanelContent>
            <app-scene-add-blocks [categories]="['Slides']"
            [addBlockType]="'BLOCK_COMPONENTS'"></app-scene-add-blocks>
          </ng-template>
          <ng-template #scenesTemplate matExpansionPanelContent>
            <app-scene-add-content [addBlockType]="'BLOCK_SCENES'"></app-scene-add-content>
          </ng-template>
          <ng-template #resourcesTemplate matExpansionPanelContent>
            <app-scene-add-content [addBlockType]="'BLOCK_RESOURCES'"></app-scene-add-content>
          </ng-template>
          <!--                            <ng-template #schedulersTemplate matExpansionPanelContent>-->
          <!--                                <app-scene-add-blocks [addBlockType]="'BLOCK_SCHEDULER'"></app-scene-add-blocks>-->
        <!--                            </ng-template>-->
        <ng-template #stickersTemplate matExpansionPanelContent>
          <app-scene-add-sticker></app-scene-add-sticker>
        </ng-template>
        <ng-template #addAnimationTemplate matExpansionPanelContent>
          <app-scene-add-animation></app-scene-add-animation>
        </ng-template>
        <ng-template #backgroundsTemplate matExpansionPanelContent>
          <app-backgrounds-texts></app-backgrounds-texts>
        </ng-template>
        <ng-template #iconsTemplate matExpansionPanelContent>
          <app-icons></app-icons>
        </ng-template>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>

</div>
</mat-drawer>
</mat-drawer-container>
</div>
